import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageShell, PageHero, PageSection } from "../components/PageShell";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { adminService } from "../services/adminService";
import FormModal from "../components/FormModal";

export default function SuperAdminAuditPage() {
  const [items, setItems] = useState([]);
  const [error, setError] = useState("");
  const [selected, setSelected] = useState(null);
  useEffect(() => {
    (async () => {
      const res = await adminService.listAuditLogs();
      if (!res.ok) return setError(res.error || "Failed to fetch audit logs");
      setItems(res.data?.items || []);
    })();
  }, []);

  return (
    <PageShell>
      <PageHero eyebrow="Super Admin" title="Audit" highlight="logs." description="Read all privileged actions with actor and target details." />
      <PageSection variant="content">
        <div className="mx-auto max-w-7xl grid gap-6">
          <div className="flex gap-2"><Link to="/super-admin" className="px-4 py-2 rounded-full border border-border text-sm">Back to Super Admin</Link></div>
          {error ? <Card><CardContent className="py-4 text-sm text-destructive">{error}</CardContent></Card> : null}
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {items.map((log) => (
              <Card key={log._id} className="cursor-pointer hover:-translate-y-0.5 transition-all" onClick={() => setSelected(log)}>
                <CardHeader><CardTitle className="text-base">{log.action}</CardTitle></CardHeader>
                <CardContent className="text-xs text-muted-foreground grid gap-1">
                  <div>Type: {log.logType || "audit"}</div>
                  <div>User: {log.actor?.name || log.actor?.email || log.actorUid || "-"}</div>
                  <div>Target: {log.targetType} / {log.targetId || "-"}</div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </PageSection>
      <FormModal open={Boolean(selected)} title="Audit Log Details" onClose={() => setSelected(null)}>
        <div className="grid gap-2 text-sm">
          <div><b>Type:</b> {selected?.logType || "audit"}</div>
          <div><b>Action:</b> {selected?.action || "-"}</div>
          <div><b>User:</b> {selected?.actor?.name || "-"} ({selected?.actor?.email || "-"})</div>
          <div><b>UID:</b> {selected?.actor?.uid || selected?.actorUid || "-"}</div>
          <div><b>Role:</b> {selected?.actor?.role || "-"}</div>
          <div><b>Target:</b> {selected?.targetType || "-"} / {selected?.targetId || "-"}</div>
          <div className="max-h-56 overflow-auto whitespace-pre-wrap rounded-xl border border-border p-3 bg-background">
            {JSON.stringify(selected?.metadata || {}, null, 2)}
          </div>
        </div>
      </FormModal>
    </PageShell>
  );
}

